import type { TranslationCatalog } from "../TranslationManager";

export const en: TranslationCatalog = {
  "labels.cardNumber": "Card number",
  "labels.expirationDate": "Expiration date",
  "labels.cvc": "Security code",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Your card number is invalid.",
  "errors.invalidExpiryDate": "Your card's expiration date is invalid.",
  "errors.invalidCvc": "Your card's security code is invalid.",
  "errors.incompleteCardNumber": "Your card number is incomplete.",
  "errors.incompleteExpiryDate": "Your card's expiration date is incomplete.",
  "errors.incompleteCvc": "Your card's security code is incomplete.",
  "errors.expiredCard": "Your card has expired.",
  "aria.cardNumber": "Card number",
  "aria.expirationDate": "Expiration date",
  "aria.cvc": "Security code",
  "aria.cardInput": "Card information",
};
